













































import Vue from "vue";
import AlertService from "@/services/alertService";
import { getUser } from "@/utils/getUser";

function greeting() {
  const d = new Date();
  const time = d.getHours();
  if (time < 12) {
    return "Good morning";
  }
  if (time > 12) {
    return "Good afternoon";
  }
  if (time > 18) {
    return "Good evening";
  }
}

export default Vue.extend({
  data() {
    const user = getUser();
    return {
      user: user?.given_name,
      openCount: "",
      greeting: greeting(),
      isLoaded: false
    };
  },
});
